export const mergeQueueAlias = "__commit_queue";
export const githubMergeQueueUser = "github_merge_queue";
export const unlinkedPRUsers = new Set(["github_pull_request", "parent_patch"]);
